<div class="modal-header">
  <button type="button" class="close" ng-click="ctrl.close()">×</button>
  <h4 class="modal-title">Selecione {{ctrl.itemName}}(s)</h4>
</div>
<div class="modal-body product-modal">
  <input class="m-b-sm form-control" ng-model="ctrl.filter" placeholder="Filtro...">
  <table class="table table-hover">
    <thead>
      <tr>
        <th></th>
        <th class="full-width">{{ctrl.itemName}}</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="item in ctrl.items | filter:ctrl.filterParam(ctrl.filter)" ng-class="{info: ctrl.selected.includes(item)}" class="pointer" ng-click="ctrl.toggle(item)">
        <td>
          <input type="checkbox" name="items[]" ng-checked="ctrl.selected.includes(item)" ng-if="ctrl.allowMultiple">
          <input type="radio" name="item" ng-checked="ctrl.selected.includes(item)" ng-if="!ctrl.allowMultiple">
        </td>
        <td class="full-width">{{item[ctrl.descriptionKey]}}</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal-footer text-right">
  <button type="button" class="btn btn-white" ng-click="ctrl.close()">Cancelar</button>
  <button type="button" class="btn btn-primary" ng-click="ctrl.save()">Selecionar</button>
</div>
